import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  name: PropTypes.string.isRequired,
  onChangeRunName: PropTypes.func.isRequired
};
const defaultProps = {};

const RunNameInput = ({ name, onChangeRunName }) => {
  return (
    <div className="run-name-input">
      <label className="col-form-label col-form-label-sm">
        Quant run name
      </label>
      <div className="input-wrapper">
        <input
          type="text"
          value={name}
          className="form-control form-control-sm"
          placeholder="Enter the name"
          onChange={(event) => onChangeRunName(event.target.value)}
        />
      </div>
    </div>
  );
};

export default RunNameInput;

RunNameInput.propTypes = propTypes;
RunNameInput.defaultProps = defaultProps;
